import _ from 'lodash';
import { useForm } from 'react-hook-form';
import React, { Component, Fragment, useState } from 'react';
import { inject, observer } from 'mobx-react';
import ReactModal from 'react-modal';
import { toast } from 'react-toastify';
import autobind from 'autobind-decorator';
import { NavLink } from 'react-router-dom';

import FieldFactory from 'common/components/field-factory';
import ItemSelector from 'common/components/item-selector';
import ItemCarousel from 'common/components/item-carousel';
// import ItemCarousel from 'client/main-ui/components/item-carousel';

import EditImage from 'client/shared/components/edit-image/edit-image';

import { Text } from 'common/components/field-factory/fields';

const injectStores = inject(
    ({
        artistStore,
        playlistStore,
        genreStore,
		songsStore,
		albumsStore
    }) => ({ artistStore, playlistStore, genreStore, songsStore, albumsStore })
);

const getPlaylist = (playlistStore, location) => {
	const { listType, genre={ _id: '0', label: 0 }, showOnFrontPage } = location.data || {};

	if (listType == "NEW_RELEASES") {
		let playlist = playlistStore.getNewReleases();
		if (playlist) {
			return playlist;
		}
	}

	const { playlist = playlistStore.data.playlist.toPOJO() } = location.data || {};

	playlistStore.setPlaylistType(playlist._id, listType);
	playlistStore.setPlaylistGenre(playlist._id, genre._id);
	playlistStore.setPlaylistShow(playlist._id, showOnFrontPage);

	return playlist;
}

const navToReturn = (location, history) => {
	const { returnURL = "/manage-lists", listType } = location.data || {};
	// if (listType != 'NEW_RELEASES') {
	// }
	history.push(returnURL);
}

const handleClick = ({ playlistStore }) => {
	const playlist = playlistStore.data.playlist.toPOJO();

	if (!playlist.title) {
		toast.error("No title has been entered, please add a title and try again.");
		return;
	}

	if (!playlist.itemIDs.length > 0) {
		toast.error("No songs selected, please select some songs and try again.");
		return;
	}

	if (playlist._id) {
		playlistStore.updatePlaylist(playlist);
	} else {
		playlistStore.savePlaylist(playlist);
	}
}

const getTitle = (listType, listId) => {
	const s = (listId ? 'EDIT ' : 'NEW ');
	switch(listType.toUpperCase()) {
		case 'ARTIST': 
			return s + 'ARTIST LIST';
		case 'ALBUM': 
			return s + 'ALBUM LIST';
		case 'SONGS': 
			return s + 'SONG LIST';
		case 'PLAYLIST': 
			return s + 'MUZADO RADIO LIST';
		case 'NEW_RELEASES': 
			return s + '"NEW RELEASES"';
	}
}

const ListEditor = injectStores(
    observer(({ artistStore, playlistStore, genreStore, songsStore, albumsStore, location, history }) => {
		const { listId=false, listType="SONGS", genre={ _id: '0' }, showOnFrontPage=true, returnURL } = location.data || {};

		let playlist = getPlaylist(playlistStore, location);

		const isArtistList = listType == "ARTIST";
		const isAlbumList = listType == "ALBUM";
		const isSongList = !isAlbumList && !isArtistList;

		const { register, control, handleSubmit } = useForm();
		let [previewTitle, setPreviewTitle] = useState(playlist.title);

		let selectedItems = (
			isArtistList ?
				artistStore.getArtistByID(playlist.itemIDs) || []
			: (
				isAlbumList ?
					albumsStore.getAlbumByID(playlist.itemIDs) || []
				:
					songsStore.getSongByID(playlist.itemIDs) || []
			)
		);

		return (
			<div className="grid-x grid-padding-x">
				<div className="cell small-12 padding-left-1">
					<h3 data-ta="muzadoPlaylistEditorHeader">{ getTitle(listType, playlist._id) }</h3>
				</div>

				<div className="grid-x margin-left-1">
					<div className="cell small-7" data-ta="playlistTitleInputContainer">
						<Text
							register={ register }
							inputClass="admin-field"
							noFieldClass={false}
							fieldKey="playlist.title"
							placeholder={ playlist.title }
							defaultvalue={ playlist.title }
							dataId={ playlist._id }
							onBlur={(e) => {setPreviewTitle(e.target.value)}}
						/>
					</div>
					<div className="cell small-5 text-center translate-fix">
						{ listType != 'NEW_RELEASES' ? 	
							<button
								data-ta="closePlaylistModalBtn"
								className="button neo mdl margin-right-1"
								onClick={ () => navToReturn(location, history) }
							>
								<i className="fas fa-times padding-right-1" />Cancel
							</button>
						: null }
						<button
							data-ta="savePlaylistModalBtn"
							className="button neo mdl"
							onClick={ handleSubmit(({ playlist: { title }}) => {
								playlistStore.set({ key: 'title', value: title });
								handleClick({ playlistStore });
								navToReturn(location, history);
							}) }
							disabled={ (selectedItems.length == 0) }
						>
							<i className="fas fa-save padding-right-1" />Save
						</button>
					</div>
					<div className="cell small-12 text-left" data-ta="itemSelectionColumn">
						<ItemSelector
							addSong={ (itemID) => {
								playlistStore.addItemToPlaylist(playlist._id, itemID);
							} } // LEGACY PASSTHRU
							removeSong={ (itemID) => {
								playlistStore.removeItemFromPlaylist(playlist._id, itemID);
							} } // LEGACY PASSTHRU
							addItem={ (itemID) => {
								playlistStore.addItemToPlaylist(playlist._id, itemID);
							} }
							removeItem={ (itemID) => {
								playlistStore.removeItemFromPlaylist(playlist._id, itemID);
							} }
							onDragEnd={ (dropResult) => {
								playlistStore.reorderPlaylist(dropResult, playlist._id);
							} }
							listType={ listType }
							itemList={ ( isArtistList ? artistStore.artists : ( isAlbumList ? albumsStore.albums : songsStore.songs ) ) }
							selectedItems={ selectedItems }
							genre={ genre }
						/>
						{ listType != 'NEW_RELEASES' ? 	
						<>
							<h4 className="margin-left-1 margin-top-2">PREVIEW</h4>
							<ItemCarousel
								sectionLabel={ previewTitle || "--- UNTITLED ---" }
								listType={ listType }
								items={ selectedItems } 
							/>
						</> 
						: null }

					</div>
				</div>
				
			</div>
		);
	})
);

// @inject('', 'songsStore', 'albumsStore', 'formStore', 'artistStore', 'genreStore')
// @observer
// class ListEditorOld extends React.Component {
// 	componentDidMount () {
// 		/* TODO: COde herez?? */
// 	}
	
// 	render () {
// 		// if (this.playlistStore.isLoading || this.songsStore.isLoading) {

// 		// 	return (<div className="loading-spinner large"></div>);
// 		// }
// 		// const { listType, listId=false } = this.props.location.data;
// 		const {
// 			songsStore,
// 			albumsStore,
// 			artistStore,
// 		} = this.props;
// 		const { listId=false, listType="SONGS", genre={ _id: '0' }, showOnFrontPage=true, returnURL } = this.props.location.data;

// 		let playlist = this.getPlaylist();
// 		const Field = this.getField();

// 		const isArtistList = listType == "ARTIST";
// 		const isAlbumList = listType == "ALBUM";
// 		const isSongList = !isAlbumList && !isArtistList;

// 		let selectedItems = (
// 			isArtistList ?
// 				artistStore.getArtistByID(playlist.itemIDs) || []
// 			: (
// 				isAlbumList ?
// 					albumsStore.getAlbumByID(playlist.itemIDs) || []
// 				:
// 					songsStore.getSongByID(playlist.itemIDs) || []
// 			)
// 		);

// 		return (
// 			<div className="grid-x grid-padding-x">
// 				<div className="cell small-12 padding-left-1">
// 					<h3 data-ta="muzadoPlaylistEditorHeader">{ this.getTitle(listType, playlist._id) }</h3>
// 				</div>

// 				<div className="grid-x margin-left-1">
// 					<div className="cell small-7" data-ta="playlistTitleInputContainer">
// 						<Field
// 							inputClass="admin-field"
// 							noFieldClass={false}
// 							fieldKey="playlist.title"
// 							placeholder={ playlist.title }
// 							defaultvalue={ playlist.title }
// 						/>
// 					</div>
// 					<div className="cell small-5 text-center translate-fix">
// 						{ listType != 'NEW_RELEASES' ? 	
// 							<button
// 								data-ta="closePlaylistModalBtn"
// 								className="button neo mdl margin-right-1"
// 								onClick={ this.navToReturn }
// 							>
// 								<i className="fas fa-times padding-right-1" />Cancel
// 							</button>
// 						: null }
// 						<button
// 							data-ta="savePlaylistModalBtn"
// 							className="button neo mdl"
// 							onClick={ this.onClick }
// 							disabled={ (selectedItems.length == 0) }
// 						>
// 							<i className="fas fa-save padding-right-1" />Save
// 						</button>
// 					</div>
// 					<div className="cell small-12 text-left" data-ta="itemSelectionColumn">
// 						<ItemSelector
// 							addSong={ this.addSong } // LEGACY PASSTHRU
// 							removeSong={ this.removeSong } // LEGACY PASSTHRU
// 							addItem={ this.addItem }
// 							removeItem={ this.removeItem }
// 							onDragEnd={ this.reorderPlaylist }
// 							listType={ listType }
// 							itemList={ ( isArtistList ? artistStore.artists : ( isAlbumList ? albumsStore.albums : songsStore.songs ) ) }
// 							selectedItems={ selectedItems }
// 							genre={ genre }
// 						/>
// 						{ listType != 'NEW_RELEASES' ? 	
// 						<>
// 							<h4 className="margin-left-1 margin-top-2">PREVIEW</h4>
// 							<ItemCarousel
// 								sectionLabel={ playlist.title || "--- UNTITLED ---" }
// 								listType={ listType }
// 								items={ selectedItems } 
// 							/>
// 						</> 
// 						: null }

// 					</div>
// 				</div>
				
// 			</div>
// 		);
// 	}

// 	getField () {
// 		const { playlistStore: store, formStore } = this.props;
// 		const playlist = this.getPlaylist();
// 		const { _id: dataId } = playlist;

// 		return (props) => {
// 			const propsObj = { formStore, store };

// 			if (_.isEmpty(dataId) !== true) {

// 				Object.assign(propsObj, { dataId });
// 			}

// 			return (
// 				<FieldFactory { ...props } { ...propsObj } />
// 			);
// 		}
// 	}

// 	getPlaylist () {
// 		const { playlistStore} = this.props;
// 		const { listType, genre={ _id: '0', label: 0 }, showOnFrontPage } = this.props.location.data;

// 		if (listType == "NEW_RELEASES") {
// 			let playlist = playlistStore.getNewReleases();
// 			if (playlist) {
// 				return playlist;
// 			}
// 		}

// 		const { playlist = playlistStore.data.playlist.toPOJO() } = this.props.location.data;

// 		playlistStore.setPlaylistType(playlist._id, listType);
// 		playlistStore.setPlaylistGenre(playlist._id, genre._id);
// 		playlistStore.setPlaylistShow(playlist._id, showOnFrontPage);

// 		return playlist;
// 	}

// 	getPlaylistByID (_id) {
// 		const { playlistStore } = this.props;
// 		return playlistStore.getPlaylistByID(_id);
// 	}

// 	getTitle (listType, listId) {
// 		const s = (listId ? 'EDIT ' : 'NEW ');
// 		switch(listType.toUpperCase()) {
// 			case 'ARTIST': 
// 				return s + 'ARTIST LIST';
// 			case 'ALBUM': 
// 				return s + 'ALBUM LIST';
// 			case 'SONGS': 
// 				return s + 'SONG LIST';
// 			case 'PLAYLIST': 
// 				return s + 'MUZADO RAIDO LIST';
// 			case 'NEW_RELEASES': 
// 				return s + '"NEW RELEASES"';
// 		}
// 	}

// 	@autobind
// 	addItem (itemID) {
// 		const { playlistStore } = this.props;
// 		const { _id } = this.getPlaylist();
// 		playlistStore.addItemToPlaylist(_id, itemID);
// 	}

// 	@autobind
// 	removeItem (itemID) {
// 		const { playlistStore } = this.props;
// 		const { _id } = this.getPlaylist();
// 		playlistStore.removeItemFromPlaylist(_id, itemID);
// 	}


// 	@autobind
// 	addSong (songID) { // LEGACY SHIM
// 		addItem (songID);
// 	}

// 	@autobind
// 	removeSong (songID) { // LEGACY SHIM
// 		removeItem (songID);
// 	}

// 	@autobind
// 	reorderPlaylist (dropResult) {
// 		const { playlistStore } = this.props;
// 		const { _id } = this.getPlaylist();
// 		playlistStore.reorderPlaylist(dropResult, _id);
// 	}

// 	@autobind
// 	onClick () {
// 		const { playlistStore } = this.props;
// 		const { listType, genre } = this.props.location.data;
// 		const playlist = this.getPlaylist();

// 		if (!playlist.title) {
// 			toast.error("No title has been entered, please add a title and try again.");
// 			return;
// 		}

// 		if (!playlist.itemIDs.length > 0) {
// 			toast.error("No songs selected, please select some songs and try again.");
// 			return;
// 		}

// 		if (playlist._id) {
// 			playlistStore.updatePlaylist(playlist);
// 		} else {
// 			playlistStore.savePlaylist(playlist);
// 		}

// 		this.navToReturn();
// 	}

// 	// @autobind
// 	// handleOpenModal () {
// 	// 	this.setState({
// 	// 		modalIsOpen: true
// 	// 	});
// 	// }

// 	// @autobind
// 	// handleCloseModal () {
// 	// 	this.setState({
// 	// 		modalIsOpen: false
// 	// 	});
// 	// }

// 	@autobind
// 	async handleImageCrop (imgData) {
// 		const { playlistStore } = this.props;
// 		const { _id } = this.getPlaylist();

// 		if (_.isEmpty(_id)) {

// 			playlistStore.set({
// 				key: 'imgData',
// 				value: imgData
// 			});

// 			return;
// 		}

// 		await playlistStore.savePlaylistArtwork({ _id, imgData }, {
// 			silent: true
// 		});
// 	}
	
// 	@autobind
// 	navToReturn() {
// 		const { returnURL = "/manage-lists", listType } = this.props.location.data;
// 		// if (listType != 'NEW_RELEASES') {
// 		// }
// 		this.props.history.push(returnURL);

// 	}

// 	@autobind
// 	onCancel() {
// 		const { playlistStore } = this.props;
// 		playlistStore.clearPlaylistInfo();
// 		this.navToReturn();
// 	}


// }

export default ListEditor;

